import { DOWNLOAD_LEDGERS, DOWNLOAD_LEDGERS_SUCCESS, DOWNLOAD_LEDGERS_ERROR, DOWNLOAD_LEDGERS_EMPTY } from '../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetDownloadLedgers = (state = initialState, action) => {
  switch (action.type) {
    case DOWNLOAD_LEDGERS:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case DOWNLOAD_LEDGERS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case DOWNLOAD_LEDGERS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case DOWNLOAD_LEDGERS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetDownloadLedgers;
